export default function diffInMinutes(dt2, dt1) {
    let diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
}

// Get the end-user's locale
export function getLang() {
    if (navigator.languages !== undefined) return navigator.languages[0];
    return navigator.language;
}

// Convert unix time (long) into a date/time string following the user's locale
export function getDateTime(unixTime, locale) {
    const dt = new Date(parseInt(unixTime, 10));
    return `${dt.toLocaleDateString(locale)} ${dt.toLocaleTimeString(locale)}`;
}
